import React, { useState, } from 'react'
import { useForm } from 'react-hook-form'
import profile from '../../assets/profile.png'
import { updateProfile } from '../../api'
import { userLogin } from '../../state/userSlice'
import Loader from '../../components/loader/Loader';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const ProfileForm = ({user, staff, dispatch, fetchUserInfo}) => {
  const [image, setImage] = useState()
  const [file, setFile] = useState()
  const [isLoading, setIsLoading] = useState(false)
  
  const userValue = {
    firstName: staff?.firstName || user?.firstName || '',
    lastName: staff?.lastName || user?.lastName || '',
    email: staff?.email || user?.email || '',
    phone: staff?.phone || user?.phone || '',
    department: staff?.department || user?.department || '',
    role: staff?.role || user?.role || '',
    gender: staff?.gender || user?.gender || '',
    birthDay: staff?.birthDay || user?.birthDay || '',
    joinDate: staff?.joinDate || user?.joinDate || '',
    street: staff?.address?.street || user?.address?.street || '',
    state: staff?.address?.state || user?.address?.state || '',
    country: staff?.address?.country || user?.address?.country || '',
    accountName: staff?.bankInfo?.accountName || user?.bankInfo?.accountName || '',
    accountNo: staff?.bankInfo?.accountNo || user?.bankInfo?.accountNo || '',
    bankName: staff?.bankInfo?.bankName || user?.bankInfo?.bankName || '',
    salaryAmount: staff?.bankInfo?.salaryAmount || user?.bankInfo?.salaryAmount || '',
    salaryBasis: staff?.bankInfo?.salaryBasis || user?.bankInfo?.salaryBasis || '',
    paymentType: staff?.bankInfo?.paymentType || user?.bankInfo?.paymentType || '',
  }
  const {
    register,
    handleSubmit,
    formState:{errors},
    reset
  } = useForm({
    mode: 'onChange',
    defaultValues: {...userValue}
  })

  const handleFile = (e)=>{
    const imgFile = e.target.files[0]
    setFile(imgFile)
    if (imgFile && /\.(png|jpg|jpeg)$/.test(imgFile.name.toLowerCase())) {
      const reader = URL.createObjectURL(imgFile)
      setImage(reader);
  } else {
    alert('Please select a valid PNG, JPG, or JPEG file.');
    e.target.value = null;
  }
  }

  const handleUpdate = async (data)=>{
    setIsLoading(true)
    let id;
    try{
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key]);
      }
      formData.append("upload", file)
      if(staff?._id){
        id = staff?._id
      }else{
        id = user?._id
      }
      const res = await updateProfile(user?.token, formData, id)
      if(res?.success){
        fetchUserInfo()
        const newData = {token: res?.token, ...res?.user}
        dispatch(userLogin(newData))
        MySwal.fire({
          icon: 'success',
          title: "Successfull",
          text: res?.message,
          showConfirmButton: false,
          timer: 4000
        });
      }else{
        MySwal.fire({
          icon: 'error',
          title: "Oops...",
          text: res?.message,
          showConfirmButton: false,
          timer: 4000
        });
      }
      setIsLoading(false)
    }catch(error){
      setIsLoading(false)
      console.log(error)
      MySwal.fire({
        icon: 'error',
        title: "Error Occurred!",
        text: "There's an error processing your request, Try again",
        showConfirmButton: false,
        timer: 4000
      });
    }
  }

  return (
    <form className='profile__form' onSubmit={handleSubmit(handleUpdate)}>

      <div className="profile__form-list">
        {/* FIRSTNAME */}
        <div className="profile__form-item">
          <label htmlFor="firstName" className="profile__form-label">
            Firstname
          </label>
          <input type="text" name='firstName' 
          className="profile__form-input" 
          {...register('firstName',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.firstName && errors.firstName.message}
          </span>
        </div>

        {/* LASTNAME */}
        <div className="profile__form-item">
          <label htmlFor="lastName" className="profile__form-label">
            Lastname
          </label>
          <input type="text" name='lastName' className="profile__form-input" 
          {...register('lastName',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.lastName && errors.lastName.message}
          </span>
        </div>

        {/* PHONE */}
        <div className="profile__form-item">
          <label htmlFor="phone" className="profile__form-label">
            Phone
          </label>
          <input type="tel" name='phone' className="profile__form-input" 
          {...register('phone',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.phone && errors.phone.message}
          </span>
        </div>

        {/* EMAIL */}
        <div className="profile__form-item">
          <label htmlFor="email" className="profile__form-label">
            Email
          </label>
          <input type="email" name='email' className="profile__form-input" 
          {...register('email',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.email && errors.email.message}
          </span>
        </div>

        {/* DEPARTMENT */}
        <div className="profile__form-item">
          <label htmlFor="department" className="profile__form-label">
            Department
          </label>
          <select name="department" className="profile__form-input"
          {...register('department',{required: 'This field is required'})}>
            <option disabled>Select Department</option>
            <option value="" disabled>Select a department</option>
            <option value="Account">Account</option>
            <option value="Admin">Admin</option>
            <option value="Compliance">Compliance</option>
            <option value="HR">HR</option>
            <option value="IT">IT</option>
            <option value="Sales">Sales</option>
            <option value="Social Media">Social Media</option>
            <option value="Ticket">Ticket</option>
            <option value="Tour">Tour</option>
            <option value="Visa">Visa</option>
          </select>
          <span className="profile__form-error">
            {errors.department && errors.department.message}
          </span>
        </div>

        {/* ROLE */}
        <div className="profile__form-item">
          <label htmlFor="role" className="profile__form-label">
            Role
          </label>
          <select name="role" className="profile__form-input"
          {...register('role',{required: 'This field is required'})}>
            <option disabled>Select role</option>
            <option value="Officer">Officer</option>
            <option value="Supervisor">Supervisor</option>
          </select>
          <span className="profile__form-error">
            {errors.role && errors.role.message}
          </span>
        </div>

        {/* GENDER */}
        <div className="profile__form-item">
          <label htmlFor="gender" className="profile__form-label">
            Gender
          </label>
          <select name="gender" className="profile__form-input"
          {...register('gender',{required: 'This field is required'})}>
            <option disabled>Select gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          <span className="profile__form-error">
            {errors.gender && errors.gender.message}
          </span>
        </div>

        {/* BIRTHDAY */}
        <div className="profile__form-item">
          <label htmlFor="birthDay" className="profile__form-label">
            Date of Birth
          </label>
          <input type="date" name='birthDay' className="profile__form-input" 
          {...register('birthDay',{required: 'This field is required'})}
          max={new Date().toISOString().split('T')[0]}/>
          <span className="profile__form-error">
            {errors.birthDay && errors.birthDay.message}
          </span>
        </div>

        {/* JOIN DATE */}
        <div className="profile__form-item">
          <label htmlFor="joinDate" className="profile__form-label">
            Join Date
          </label>
          <input type="date" name='joinDate' className="profile__form-input" 
          {...register('joinDate')}/>
          <span className="profile__form-error">
            {errors.joinDate && errors.joinDate.message}
          </span>
        </div>
        {/* STATE */}
        <div className="profile__form-item">
          <label htmlFor="street" className="profile__form-label">
            Street
          </label>
          <input type="text" name='street' className="profile__form-input" 
          {...register('street',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.street && errors.street.message}
          </span>
        </div>
        {/* STATE */}
        <div className="profile__form-item">
          <label htmlFor="state" className="profile__form-label">
            State
          </label>
          <input type="text" name='state' className="profile__form-input" 
          {...register('state',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.state && errors.state.message}
          </span>
        </div>

        {/* COUNTRY */}
        <div className="profile__form-item">
          <label htmlFor="country" className="profile__form-label">
            Country
          </label>
          <input type="text" name='country' className="profile__form-input" 
          {...register('country',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.country && errors.country.message}
          </span>
        </div>

      </div>
      
      {/* FORM TITLE */}
      <h4 className="profile__form-title">Bank Details</h4>

      <div className="profile__form-list">

        {/* BANK ACCOUNT NAME */}
        <div className="profile__form-item">
          <label htmlFor="accountName" className="profile__form-label">
            ACCOUNT NAME
          </label>
          <input type="text" name='accountName' className="profile__form-input" 
          {...register('accountName',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.accountName && errors.accountName.message}
          </span>
        </div>

        {/* BANK ACCOUNT NUMBER */}
        <div className="profile__form-item">
          <label htmlFor="accountNo" className="profile__form-label">
            ACCOUNT NO
          </label>
          <input type="text" name='accountNo' className="profile__form-input" 
          {...register('accountNo',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.accountNo && errors.accountNo.message}
          </span>
        </div>

        {/* BANK NAME */}
        <div className="profile__form-item">
          <label htmlFor="bankName" className="profile__form-label">
            BANK NAME
          </label>
          <input type="text" name='bankName' className="profile__form-input" 
          {...register('bankName',{required: 'This field is required'})}/>
          <span className="profile__form-error">
            {errors.bankName && errors.bankName.message}
          </span>
        </div>

        {/* SALARY AMOUNT */}
        <div className="profile__form-item">
          <label htmlFor="salaryAmount" className="profile__form-label">
            SALARY AMOUNT <span>(For Administrator only.)</span>
          </label>
          <input type="text" name='salaryAmount' className="profile__form-input" 
          {...register('salaryAmount', 
          user?.department === 'HR' || user?.role === 'Administrator'
          ? {required: 'This field is required'} : '')}
          disabled={user?.department !== 'HR' && user?.role !== 'Administrator'}
          />
          <span className="profile__form-error">
            {errors.salaryAmount && errors.salaryAmount.message}
          </span>
        </div>

        {/* SALARY BASIS */}
        <div className="profile__form-item">
          <label htmlFor="salaryBasis" className="profile__form-label">
            SALARY BASIS <span>(For Administrator only.)</span>
          </label>
          <select name="salaryBasis" className="profile__form-input"
          {...register('salaryBasis', 
          user?.department === 'HR' || user?.role === 'Administrator'
          ? {required: 'This field is required'} : '')}
          disabled={user?.department !== 'HR' && user?.role !== 'Administrator'}>
            <option disabled>Select salary basis</option>
            <option value="Hourly">Hourly</option>
            <option value="Daily">Daily</option>
            <option value="Weekkly">Weekkly</option>
            <option value="Monthly">Monthly</option>
          </select>
          <span className="profile__form-error">
            {errors.salaryBasis && errors.salaryBasis.message}
          </span>
        </div>

        {/* PAYMENT TYPE */}
        <div className="profile__form-item">
          <label htmlFor="paymentType" className="profile__form-label">
            PAYMENT TYPE <span>(For Administrator only.)</span>
          </label>
          <select name="paymentType" className="profile__form-input"
          {...register('paymentType', user?.department === 'HR' || user?.role === 'Administrator'
          ? {required: 'This field is required'} : '')}
          disabled={user?.department !== 'HR' && user?.role !== 'Administrator'}>
            <option disabled>Select payment type</option>
            <option value="Bank  Transfer">Bank Transfer</option>
            <option value="Cash">Cash</option>
            <option value="Check">Check</option>
          </select>
          <span className="profile__form-error">
            {errors.paymentType && errors.paymentType.message}
          </span>
        </div>
        {/* IMAGE */}
        <div className="profile__form-item">
          <img src={image ?? profile} alt="Profile Image" 
          className='profile__form-img'/>
        </div>
        {/* IMAGE INPUT */}
        <div className="profile__form-item">
          <input type="file" name="upload" 
          onChange={(e)=>handleFile(e)}
          accept=".png, .jpg, .jpeg"
          id="upload" className="profile__form-label_input"/>
          <label htmlFor="upload" className="profile__form-label_profile">
            Upload profile picture
            <i class='bx bx-image-add profile__form-label_icon'></i>
          </label>
        </div>

      </div>

      {/* SUBMIT BUTTON */}
      <div className="profile__form-item">
        {isLoading ? <Loader/> :
        <button type='submit'
        className="profile__form-btn button">
          Submit
        </button>
        }
      </div>

    </form>
  )
}

export default ProfileForm